import AppService from 'App/legacy/AppService';
import StateRouter from 'App/services/StateRouter';

/**
 * Client-card twin of contactCardNavigation. Every in-app link to a client card
 * goes through these two helpers.
 */
export const goToClientCard = (clientId: number) => {
	StateRouter.go('account.dashboard', { id: clientId });
};

/**
 * `activityId` makes the card expand that activity in its timeline. It is a
 * declared query param on the angular card (`account.dashboard`, url
 * `?activityId`).
 */
export const getClientCardHref = (clientId: number, activityId?: number) => {
	return StateRouter.href('account.dashboard', {
		customerId: AppService.getCustomerId(),
		id: clientId,
		...(activityId ? { activityId } : {})
	});
};
